<template>
  <div class="topic-view-page-wrapper app-bg-white">
    <div class="main-content">
      <BaseLoading v-if="loading"></BaseLoading>
      <div v-else-if="!topic" class="empty-wrapper">
        <img :src="siteEmptyImg" />
        <p>暂时无法查看该推广专题的详细信息~</p>
      </div>
      <template v-else>
        <p v-if="isPreview" class="preview-wrapper">该页面为预览页面!!!</p>
        <DetailTopic :topic="topic"></DetailTopic>
        <WeiboCard></WeiboCard>
        <RelatedTopics :topic="topic"></RelatedTopics>
      </template>
    </div>
  </div>
</template>

<script>
import siteEmptyImg from '@/assets/img/common/site-empty-search.png'
import DetailTopic from './components/DetailTopic'
import RelatedTopics from './components/RelatedTopics'
import WeiboCard from '@/views/article/view/components/WeiboCard'
import BaseLoading from '@/components/base/BaseLoading'
import { THIRD_API } from '@/global/config'

export default {
  components: {
    DetailTopic,
    WeiboCard,
    RelatedTopics,
    BaseLoading
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isPreview: Boolean
  },
  data() {
    return {
      siteEmptyImg,
      topic: null,
      loading: true
    }
  },
  created() {
    this.getTopicDetail()
  },
  methods: {
    async getTopicDetail() {
      const res = await this.$http.get(THIRD_API.alkTopicDetail.link, {
        params: {
          id: this.id
        }
      })
      this.loading = false
      this.topic = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.topic-view-page-wrapper {
  padding: 100px 0 88px;
}
.main-content {
  width: 984px;
  margin: 0 auto;
}
.empty-wrapper {
  padding: 100px 0;
  color: #aaaaaa;
  font-size: 14px;
  text-align: center;
  img {
    width: 185px;
    height: 170px;
    margin-bottom: 36px;
  }
}
.preview-wrapper {
  background-color: #ff0000;
  color: #ffff00;
  font-size: 42px;
  text-align: center;
  line-height: 120px;
  margin: -20px 0 0;
}
</style>
